<div [style.width]="width" [style.height]="height+'vh'" [style.maxHeight]="height+'vh'"  [style.minHeight]="height+'vh'">
  <canvas id="stravaChart" #strava ></canvas>
</div>
